import Joi from "@hapi/joi";
import Grid from "@material-ui/core/Grid";
import get from "lodash/get";
import toLower from "lodash/toLower";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { textinputconverter } from "../../../../../../Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "../../../../../../Component/DynamicForm/Fields/Textarea";
import { ErrorMessages } from "../../../../../../Constants";
import { isSpaceInString } from "Utils";


class define extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      open: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  async onSubmit() {
    const data = this.props.postData;
    const { currentEditData } = this.props;
    const schema = Joi.object().keys({
      policyname: Joi.string()
        .required()
        .label("E1000"),
    });
    const { error } = schema.validate({ policyname: data.policyname });

    if (error) {
      this.props.enqueueSnackbar(
        ErrorMessages[get(error, "details[0].context.label", "err")],
        {
          variant: "error",
        },
      );
    } else if (data.policyname && !isSpaceInString(data.policyname)) {
      data.policyname = data.policyname.trim();
    } else if (
      !data.exitpolicyid
      || (currentEditData
        && toLower(currentEditData.policyname) != toLower(data.policyname))
    ) {
      instance
        .post("exit/exitpolicy/isunique", {
          policyname: data.policyname,
        })
        .then(() => {
          this.props.onNextClick();
        })
        .catch(() => {
          this.props.enqueueSnackbar(ErrorMessages.E1090, {
            variant: "error",
          });
        });
    } else {
      this.props.onNextClick();
    }
  }

  async updatePostData(key, value) {
    const { postData } = this.props;
    postData[key] = value;
    this.props.updatePostData(postData);
  }

  render() {
    const { description, policyname } = this.props.postData;
    return (
      <div style={{ overflowY: "scroll", height: 400 }}>
        <Grid>
          <div className="width50">
            <DynamicForm
              fields={textinputconverter({
                value: policyname,
                label: "Lets give this Exit Policy a name",
                placeholder: "Enter policy name",
              })}
              onChange={(e) => this.updatePostData("policyname", e)}
              formKey="policyname"
            />
          </div>
          <div className="width50">
            <DynamicForm
              className="width50"
              fields={textareainputconverter({
                value: description,
                label: "Description",
                placeholder: "Enter description",
              })}
              onChange={(e) => this.updatePostData("description", e)}
              formKey="description"
            />
          </div>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(define);
